import { useAuthStore } from "../stores/auth-store";
import type { ApiResponse, RefreshResponse } from "../types/auth";
import { env } from "./env";

const BASE_URL = env.API_BASE_URL;

let refreshPromise: Promise<boolean> | null = null;

export async function attemptRefresh(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const { refreshToken } = useAuthStore.getState();
      if (!refreshToken) return false;

      const response = await fetch(`${BASE_URL}/auth/refresh`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ refresh_token: refreshToken }),
        signal: AbortSignal.timeout(10_000),
      });

      if (!response.ok) return false;

      const result: ApiResponse<RefreshResponse> = await response.json();
      const {
        access_token,
        refresh_token,
        access_token_expires_at,
      } = result.data;

      useAuthStore
        .getState()
        .setTokens(access_token, refresh_token, access_token_expires_at);
      return true;
    } catch {
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}
